module.exports = __webpack_public_path__ + "img/download-android.1f12a676.png";